

import React from "react";
import { Link } from "react-router-dom";
import { fb, insta, logo, pinterest, twitter2 } from "../../assets/imagesPath";
import Button from "../button/Button";
import PATHS from "../../routes/Paths";

const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#173363] text-white py-[6rem] pb-[2.5rem] px-40 smallScreens:px-8 smallScreens:pt-8">
      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-2 smallScreens:col-span-12 flex flex-col items-center lg:items-start">
          <img src={logo} alt="Logo" className="h-40 mb-10" />
        </div>

        <div className="col-span-10 my-autos smallScreens:col-span-12">
          <div className="flex items-center justify-end">
            <div className="flex items-center justify-between mb-16 bg-[#66758f36] p-8 rounded-3xl w-[50%] mediumScreens:w-[60%] smallScreens:w-full smallScreens:flex-col smallScreens:gap-8">
              <h3 className="text-2xl">Grow your business fast with SBAAA LLC</h3>
              <div className="flex items-center gap-4">
                <Link to={PATHS.contactUs}>
                  <Button label="Contact Us" className="blackBtn" />
                </Link>
                {/* <Button label="Hire Us" className="whiteBtn" /> */}
              </div>
            </div>
          </div>

          <ul className="space-x-20 text-[1.6rem] flex items-center justify-end smallScreens:flex-col smallScreens:space-x-0 smallScreens:space-y-5">
            <li>
              <Link to={PATHS.aboutUs} className="hover:underline">
                About
              </Link>
            </li>
            <li>
              <Link to={PATHS.terms} className="hover:underline">
                Terms of Use
              </Link>
            </li>
            <li>
              <Link to={PATHS.privacyPolicy} className="hover:underline">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to={PATHS.faqs} className="hover:underline">
                FAQs
              </Link>
            </li>
            <li>
              <Link to={PATHS.contactUs} className="hover:underline">
                Support
              </Link>
            </li>
          </ul>
        </div>
       
      </div>
      <div className="mt-20 flex items-center justify-between border-t border-white/20 pt-10 mx-[7rem] smallScreens:mx-0 smallScreens:mb-4 smallScreens:flex-col smallScreens:text-center smallScreens:gap-8">
        <p className="text-[1.6rem] smallScreens:text-xl">
          Copyright © {currentYear} SBAAA LLC - All Rights Reserved.
        </p>
        <p className="text-[1.6rem] smallScreens:text-xl">
          Design and Developed by <Link target="_blank" to="https://senewtech.com/"><b>Senew Tech</b></Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;